export const PostscriptIcon = () => {
  return (
    <img
      width="32"
      height="32"
      src="/assets/logo-postscript.png"
      alt="Postscript SMS marketing"
    />
  );
};
